import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Form, Button, InputGroup, Tab, Tabs } from "react-bootstrap";
import axiosInstance from "../../interceptor/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaDownload, FaStar, FaRegStar } from 'react-icons/fa'; // Import download icon
import { useNavigate } from "react-router-dom";

import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import NotificationService from "../Utils/NotificationService"; // Import notification service
import "./Org.css"
import "./Chat.css"
import "./AllTickets.css"
import "../Dashboard/Ticket.css";
import { formatUpworkDate, formatTime } from '../Utils/UtilityService.js'
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import FileUpload from "../Shared/FileUploader.js";
import config from "../../config.js";
import { faEnvelope, faPhone, faLink, faUser, faTag, faChevronRight, faChevronLeft, faTicketAlt, faPlusCircle, faExchangeAlt, faUserCheck, faUserSlash  } from '@fortawesome/free-solid-svg-icons';

const AllTicket = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [assignDropdown, setAssignDropdown] = useState(null);
  const [statuses, setStatuses] = useState([]);
  const [agents, setAgents] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const assignDropdownRef = useRef(null); // Ref for the assign dropdown
  const [ticketConv, setTicketConv] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null); // Track the selected agent
  const [hoverIndex, setHoverIndex] = React.useState(null);
  const [hoverConvId, setHoverConvId] = React.useState(null);
  const [formData, setFormData] = useState({
    ticket_id: '',
    message: '',
    attachments: [],
  });
  const [files, setFiles] = useState([]);
  const [ws, setWs] = useState(null);
  const selectedTicketRef = useRef(null); // Use ref to track selectedTicket
  const messagesEndRef = useRef(null);
  const [selectedTicketsStatus, setSelectedTicketsStatus] = useState([]);
  const [ticketUsers] = useState([{short: 'MY', name: "My Ticket"}, {short: 'ALL', name: "All Ticket"}]);
  const [ticketType, setTicketType] = useState('MY');
  const user = JSON.parse(localStorage.getItem("user"));
  const [key, setKey] = useState('details');
  const [lastReply, setLastReply] = useState(null);

  const [isRightPanelOpen, setIsRightPanelOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("My Tickets");
  const [accessData, setAccessData] = useState(null);
  const [isInternalNotes, setIsInternalNotes] = useState(false);
  const [ticketOperations, setTicketOperations] = useState([]);
  const [showTicketOperations, setShowTicketOperations] = useState(false);

  // Update ref whenever selectedTicket changes
  useEffect(() => {
    selectedTicketRef.current = selectedTicket;
  }, [selectedTicket]);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [ticketConv]);

  useEffect(() => {
            const socket = new WebSocket(config.REACT_APP_WEBSOCKET_URL);
            setWs(socket);
    
            // Handle incoming messages
            socket.onmessage = async (event) => {
                if (event.data instanceof Blob) {
                    // Convert Blob to text or handle it as required
                    let text = await event.data.text();
                    text = JSON.parse(text).content;
    
                    let resData = JSON.parse(await event.data.text());
                    if(resData.type == 'ticket_message' && resData.ticketStatus == 'close'){
                      fetchTickets(false,true);
                    } 
                    if(resData.type == 'ticket_message' && selectedTicketRef.current.id == resData.ticketId){
                    await fetchTicketDetails(selectedTicketRef.current.id);
                    }
                } 
            };
    
            // Cleanup on unmount
            return () => {
              if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
                  socket.close();
              }
          };
        }, []);

  // Fetch statuses and agents on component load
  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        const response = await axiosInstance.get("/api/ticket/getStatuses");
        setStatuses(response.data);
        setSelectedTicketsStatus(response.data.map((s)=> s.id));
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    };

    const fetchAgents = async () => {
      try {
        const response = await axiosInstance.get("/api/ticket/getAgentList");
        if (response.data.length > 0) {
          const unassigned = {
            id: null,
            name: "Unassigned",
            user_id: null,
            is_own_account: 0
          }
          setAgents([unassigned, ...response.data]);
        }
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    };
    fetchStatuses();
    fetchAgents();
  }, []);

  const fetchTickets = async (setSelected = true,skipLoader = false) => {
    try {
      const response = await axiosInstance.get("/api/ticket/org-tickets",{params: { statuses: selectedTicketsStatus, ticketType: ticketType }, skipLoader});
      setTickets(response.data);
      if(setSelected){
        setSelectedTicket(response.data[0]);
        // Automatically select the first ticket and fetch its details
      if (response.data.length > 0) {
        fetchTicketDetails(response.data[0].id); // Load the first ticket by default
        console.log("set ticket: selected ", selectedTicket)

      }
    } else{
      const ticketData = response.data.find(ticket => ticket.id === selectedTicketRef.current.id);
      if(ticketData){
      setSelectedTicket(ticketData);
      }
    }
      
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };
  const getAccess = async () => {
    try {
      const response = await axiosInstance.get(`/org/check-access/max_tickets`);
      setAccessData(response.data);
    } catch (err) {
      console.error("Error fetching access settings", err);
    }
  };

  useEffect(() => {
    fetchTickets();
    getAccess();
  }, [selectedTicketsStatus, ticketType]);
  
  const handleCheckboxChange = async (id) => {
    setSelectedTicketsStatus((prevSelected) => {
      if (prevSelected.includes(id)) {
        // Uncheck logic
        const updatedSelection = prevSelected.filter((ticketId) => ticketId !== id);
        console.log(`Unchecked: ${id}`, updatedSelection);
        return updatedSelection;
      } else {
        // Check logic
        const updatedSelection = [...prevSelected, id];
        console.log(`Checked: ${id}`, updatedSelection);
        return updatedSelection;
      }
    });
  };

  // Fetch ticket details when a ticket is selected
  const fetchTicketDetails = async (ticketId) => {
    try {
      const response = await axiosInstance.get(`/tickets/details?ticket_id=${ticketId}`);
      // setSelectedTicket(response.data);
      setTicketConv(response.data);
      setLastReply(response.data[response.data.length-1].userDisplayName);
    } catch (error) {
      console.error("Error fetching ticket details:", error);
    }
  };

  const handleTicketClick = (ticket) => {
    if (selectedTicket?.id === ticket.id) return;
    setSelectedTicket(ticket);
    fetchTicketDetails(ticket.id);
    setAssignDropdown(null);
    setFormData('');
    setFiles([]);
    // Clear the message input
    setNewMessage("");
  };

  const handleAssignClick = (ticket) => {
    setSelectedAgent(agents.filter((a) => a.user_id == ticket.assigned_to)[0])
    setAssignDropdown(assignDropdown === ticket.id ? null : ticket.id);

  };

  const handleStatusChange = async (ticketId, newStatus) => {
    try {
      const response = await axiosInstance.post(`/tickets/status-change`, { id: ticketId, status: newStatus });
      if(response.data.success) {
        const updatedTickets = tickets.map((ticket) =>
          ticket.id === ticketId ? { ...ticket, status: newStatus } : ticket
        );
        setTickets(updatedTickets);
        
        let filterTicket = tickets.find(ticket => ticket.id === ticketId);
  
        if (filterTicket) {
          filterTicket.status = newStatus;
          setSelectedTicket(filterTicket);
        }
        NotificationService.success(response.data.message);
        if (ws) {
          ws.send(JSON.stringify({ type: 'ticket_message', ticketStatus:newStatus, ticketId:ticketId}));
        }
      } else {
        NotificationService.error(response.data.message);
      }      
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const removeHtmlTags = (str) => {
    return str.replace(/<[^>]*>/g, "");
  };
  const handleSendMessage = async () => {
    console.log("new: ", removeHtmlTags(newMessage))
    if (!removeHtmlTags(newMessage).trim()) {
      NotificationService.error('Message is required');
      return;
    }

    try {
      const formDataToSubmit = new FormData();
      // Append the fields to FormData object
      for (let key in formData) {
        if (key === "attachments") {
          formData.attachments.forEach((file) => {
            formDataToSubmit.append("attachments", file);
          });
        }
      }
      formDataToSubmit.append("ticket_id", selectedTicket.id);
      formDataToSubmit.append("message", newMessage);
      formDataToSubmit.append("isInternalNotes", isInternalNotes);

      console.log("selectedTicket.id::", formDataToSubmit);
      const response = await axiosInstance.post("/tickets/save_conversation", formDataToSubmit, {
        headers: {
          "Content-Type": "multipart/form-data",  // Tell the server to expect multipart form data
        },
      });
      
      if(response.data.success) {
        await fetchTicketDetails(selectedTicket.id);
        setFormData('');
        setFiles([]);
        setNewMessage("");
        setIsInternalNotes(false);
        if (ws) {
          ws.send(JSON.stringify({ type: 'ticket_message', content: newMessage, ticketId:selectedTicket.id}));
        }
      } else {
        NotificationService.error(response.data.message);
      }
      
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleShareLink = async () => {
    try {
      const response = await axiosInstance.get(`/api/public/sharable-link?ticket_id=${selectedTicket.id}`);
      console.log(response.data)
      NotificationService.success(response.data.message);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const viewTicketOperations = async () => {
    try {
      const response = await axiosInstance.get(`/tickets/get-ticket-operations?ticket_id=${selectedTicket.id}`);
      console.log(response.data)
      setTicketOperations(response.data);
      setShowTicketOperations(true);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (assignDropdownRef.current && !assignDropdownRef.current.contains(e.target)) {
        setAssignDropdown(null); // Close the dropdown if the click is outside
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick); // Clean up the event listener on component unmount
    };
  }, []);

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
    },
  };

  const editorStyles = {
    minHeight: "100px",
    maxHeight: "150px", // Set the height for the content area
    overflowY: "auto", // Enable vertical scrolling for content overflow
    padding: "5px",
    borderRadius: "0 0 5px 5px", // Rounded corners for the bottom of the editor
    width: "85%",
  };

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = styles.hoverItem.backgroundColor;
  };

  const handleMouseLeave = (e, agent) => {
    if (agent === selectedAgent) {
      e.target.style.backgroundColor = styles.selectedItem.backgroundColor;
    } else {
      e.target.style.backgroundColor = styles.listItem.backgroundColor;
    }
  };

  const handleAgentAssign = async (ticketId, agent, user_id) => {
    if (user_id === agent.user_id) {
      return;
    }
    setSelectedAgent(agent); // Set the clicked agent as selected
    try {
      const response = await axiosInstance.post(`/tickets/agent-change`, { id: ticketId, assigned_to: agent.user_id });
      if (response.data.success) {
        const updatedTickets = tickets.reduce((acc, ticket) => {
          if (ticket.id === ticketId) {
            const updatedTicket = { ...ticket, assigned_to: agent.user_id, isAssignedToSelf: agent.is_own_account };
            if (ticketType !== "MY" || agent.is_own_account) {
              acc.push(updatedTicket);
            }
          } else {
            acc.push(ticket);
          }
          return acc;
        }, []);
  
        if(updatedTickets && updatedTickets.length>0 && !agent.is_own_account && ticketType === "MY") {
          setSelectedTicket(updatedTickets[0]);
          fetchTicketDetails(updatedTickets[0].id);
        } else {
          const updatedSelected = updatedTickets.find((t) => t.id === ticketId) || null;
          if (updatedSelected) {
            setSelectedTicket(updatedSelected);
          }
        }
        setTickets(updatedTickets);
        selectedTicket.assigned_to = agent.user_id;
        selectedTicket.isAssignedToSelf = agent.is_own_account;
        setAssignDropdown(null);
        NotificationService.success(response.data.message);
      } else {
        setAssignDropdown(null);
        NotificationService.error(response.data.message);
      }
      
    } catch (error) {
      console.error("Error updating Agent:", error);
    }
  };

  const toCamelCase = (str) => {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  
  const handleDownload = async (fileUrl, fileName) => {
    try {
      if (!fileUrl) {
        throw new Error("Invalid file URL.");
      }
  
      // Fetch pre-signed URL from the backend
      const response = await axiosInstance.get("/tickets/generate-presigned-url", { params: { fileUrl } });
      const presignedUrl = response.data.presignedUrl;
  
      if (!presignedUrl) {
        throw new Error("Failed to generate pre-signed URL.");
      }
  
      // Force download using the pre-signed URL
      const link = document.createElement("a");
      link.href = presignedUrl;
      link.download = fileName || "download";
      link.target = "_blank";
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download the file. Please try again.");
    }
  };

  const handleFileChange = (selectedFiles) => {
    console.log(selectedFiles); // Handle selected files
    setFormData({
      ...formData,
      attachments: Array.from(selectedFiles), // Update to handle multiple files
    });
    setFiles(selectedFiles);
  };

  const getInitials = (senderName) => {
    if (!senderName) return '';
  
    const nameParts = senderName.trim().split(' ');
    if (nameParts.length > 1) {
      return nameParts[0].charAt(0) + nameParts[1].charAt(0);
    } else {
      return senderName.charAt(0) + senderName.charAt(1);
    }
  };

  const FormatDate = ({ datetime }) => {
    const date = new Date(datetime);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });
  
    return <span>{formattedDate}</span>;
  };

  const MessageCard = ({ avatar, ticket, index}) => {
    // State to toggle between filled and empty star
    const [isStarred, setIsStarred] = useState(false);
    const avatarClass = index % 2 === 0 ? "profile-circle-color-red" : "profile-circle-color-black";
  
    // Toggle function for star
    const toggleStar = () => {
      setIsStarred(!isStarred);
    };
    return (<div key={ticket.id}
        className={`${selectedTicket?.id === ticket.id ? "ticket-color" : "chat-ticket-details"}`}
        onClick={() => handleTicketClick(ticket)}
        style={{ cursor: "pointer", borderRadius: '0px' }}> 

       <div className="d-flex justify-content-between align-items-start border p-3 rounded shadow-sm">
        <div className="d-flex align-items-start ticket-details-style">
          <div
           className={`avatar-circle ${avatarClass}`}
          >
            {avatar}
          </div>
          <div style={{marginLeft: '6px'}}>
            <div className="details-font-value">{ticket.clientName}</div>
            <div className="details-font-value" style={{fontWeight: 'bold', color: 'black'}}>{ticket.trimmedSubject}</div>                  
            <div className="details-font-value">{ticket.descriptions}</div>                                        
          </div>
        </div>
  
        {/* Right Section (Time + Star) */}
        <div className="text-end">
          {/* <small className="text-muted d-block">{time}</small> */}
          <div className="details-font-value"><FormatDate  datetime={ticket.created_at} /></div>
          {/* <div onClick={toggleStar} style={{ cursor: "pointer" }}>
            {isStarred ? (
              <FaStar className="text-warning mt-1" />
            ) : (
              <FaRegStar className="text-warning mt-1" />
            )}
          </div> */}
        </div>
      </div>
      </div>
    );
  };
  
  const internalNotesCheckboxChange = (e) => {
    setIsInternalNotes(e.target.checked);
  };

  return (
    <div>
      <div>
        <div className="d-flex flex-column min-vh-86">
          <main className="flex-fill bg-light">
            <div className="d-flex min-vh-86">
            <div className="ticket-list-container chat-ticket-details">
              <div style={styles.ticketTypeHeader} className="chat-ticket-header">

              <div className="container mt-4">
                <div className="d-flex justify-content-between align-items-center border-bottom-grey">
                  <div className="d-flex">
                  <div
                    className={`tab-item ${activeTab === "My Tickets" ? "active-tab" : ""}`}
                    onClick={() => {setActiveTab("My Tickets"); setTicketType('MY')}}
                  >
                    My Tickets
                  </div>
                  {user?.role === "organisation" && (
                    <div
                    className={`tab-item ${activeTab === "All Tickets" ? "active-tab" : ""}`}
                    onClick={() => {setActiveTab("All Tickets"); setTicketType('ALL')}}
                  >
                    All Tickets
                  </div>
                  )}
                  </div>
                  <div><span
                    className={`profile-circle-color-dark-black add-ticket-circle ${
                      accessData && !accessData.isValid ? "profile-circle-color-dark-black-disabled" : ""
                    }`}
                    onClick={() => { if (accessData && !accessData.isValid) return; // Prevent navigation if isValid is false
                      navigate("/tickets/new");
                    }} title={accessData && !accessData.isValid ? accessData.message : ""}>+</span></div>
                </div>
              </div>
                
                
               
                <div style={styles.grid}>
                  {statuses.map((ticketStatus) => (
                    <div key={ticketStatus.id} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={ticketStatus.id}
                        checked={selectedTicketsStatus.includes(ticketStatus.id)}
                        onChange={() => handleCheckboxChange(ticketStatus.id)}
                      />
                      <label className="form-check-label" htmlFor={ticketStatus.id}>
                        {ticketStatus.name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>


              <div className="chat-ticket-details" style={styles.ticketList}>
              {tickets.length === 0 && (<p style={styles.noChats}>Tickets not available </p>)}
                {tickets.map((ticket, index) => (
                  <MessageCard
                    avatar= {ticket && ticket.clientName? getInitials(ticket.clientName).toUpperCase(): ''}
                    ticket = {ticket}
                    index = {index}
                  />
                ))}
              </div>
            </div>

              <Col md={9} className="d-flex flex-column" style={styles.ticketDetail}>
                {selectedTicket ? (
                  <div style={styles.chatContainer}>
                    <div style={styles.subjectHeader}>
                      <span style={{marginTop: '15px', marginBottom: '10px', display: 'block'}} className="ticket-subject">
                         {selectedTicket.subject}
                      </span>
                    </div>
                    <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}>
                      <hr style={{ border: "none", height: "2px", backgroundColor: "grey", flex: 1 }} />
                      <div
                        style={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                          border: "2px solid lightGrey",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsRightPanelOpen(!isRightPanelOpen)}
                      >
                        {isRightPanelOpen && <FontAwesomeIcon icon={faChevronRight} color="grey" />}
                        {!isRightPanelOpen && <FontAwesomeIcon icon={faChevronLeft} color="grey" />}  
                      </div>
                    </div>

                    <div style={styles.messagesContainer} className="chat-conv-bg">
                      <div style={{ padding: '1%', minHeight: "76%" }}>
                        {ticketConv && ticketConv.length > 0 ? (
                          ticketConv.map((conversation, index) => {
                            const senderName = conversation.userDisplayName ||
                              (conversation.sender === 'agent' ? 'Support' : 'User');
                            const initials = senderName ? senderName.charAt(0) + senderName.charAt(senderName.length - 1) : '';
                            const formattedName = toCamelCase(senderName); // Format the sender's name in camel case

                            return (
                              <div className={` ${conversation.sender === "user"
                                ? "user-conversation"
                                : "support-conversation"
                                }`}
                              >
                                <div key={index} className="mb-3" style={{ display: 'flex' }}>
                                  {/* Circle with initials (in uppercase) */}
                                  <div  className={`${conversation.sender === "user"
                                ? "avatar-circle-40 profile-circle-color-red"
                                : "avatar-circle-40 profile-circle-color-black"
                                }`}
                                  >
                                    {getInitials(senderName).toUpperCase()} {/* Initials in uppercase */}
                                  </div>
                                  <div style={{ marginLeft: '10px', minWidth: '90%' }}>
                                    {/* <span  className="conv-user">{formattedName}</span>&nbsp;<span className="text-muted" style={{ fontSize: '0.85em' }}>({formatUpworkDate(conversation.created_at)})</span> */}

                                    <div className="conv-container">
                                      <span className="conv-user">{formattedName}</span>
                                      <span className="conv-date text-muted">{formatUpworkDate(conversation.created_at)}</span>
                                    </div>
                                    <div className="padding-top-bottom-10 conv-content">
                                      <p dangerouslySetInnerHTML={{ __html: conversation.message }}></p>
                                    </div>

                                    {/* Attachments */}
                                    {conversation.attachments && conversation.attachments.length > 0 && (
                                      <div className="attatch-box-container">
                                        <div className="attatch-box-label">
                                          {conversation.attachments && conversation.attachments.length > 0 && (
                                            <div >
                                              {conversation.attachments.map((attachment, attachmentIndex) => (
                                                <div
                                                  key={attachmentIndex}
                                                  style={
                                                    (hoverIndex === attachmentIndex && hoverConvId === conversation.message_id)
                                                      ? { ...styles.attachmentContainer, ...styles.blackBorder }
                                                      : { ...styles.attachmentContainer }
                                                  }
                                                  onMouseEnter={() => { setHoverIndex(attachmentIndex); setHoverConvId(conversation.message_id); }}
                                                  onMouseLeave={() => { setHoverIndex(null); setHoverConvId(null); }}
                                                >
                                                  {/* Left Block: File Name */}
                                                  
                                                  <div style={styles.fileName}><img loading="lazy" width="30" height="30" src="assets/file-download.svg"></img>&nbsp;{attachment.file_name}</div>
                                                  {/* Right Block: Download Icon */}
                                                  <div
                                                    style={
                                                      (hoverIndex === attachmentIndex && hoverConvId === conversation.message_id)
                                                        ? { ...styles.downloadIcon, ...styles.downloadIconVisible }
                                                        : styles.downloadIcon
                                                    }
                                                  >
                                                    <a
                                                      href="#"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDownload(attachment.file_url, attachment.file_name);
                                                      }}
                                                      download
                                                    >
                                                      <img loading="lazy" width="20" height="20" src="assets/download-icon.svg" style={styles.iconStyle}></img>
                                                      {/* <FaDownload style={styles.iconStyle} /> */}
                                                    </a>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                        <div className="attatch-box-download">
                                          <span className="download-file-number">
                                            {conversation.attachments.length > 1
                                              ? `${conversation.attachments.length} files attached`
                                              : conversation.attachments.length === 1
                                              ? "1 file attached"
                                              : ""}
                                          </span>
                                          {/* <span>
                                            <img loading="lazy" width="20" height="20" src="assets/download-icon.svg"></img>
                                            {conversation.attachments.length > 1
                                              ? `Download All`
                                              : conversation.attachments.length === 1
                                              ? "Download"
                                              : ""}
                                          </span> */}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p style={{ color: "gray", textAlign: "center" }}>No conversations available.</p>
                        )}
                        <div ref={messagesEndRef} />
                      </div>
                    </div>

                    {Number(selectedTicket.status) !== Number(statuses.filter((s) => s.short_name === "CLS")[0].id) && 
                      selectedTicket.isAssignedToSelf === 1 && (
                      <div style={styles.messageInput}>                        
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: "85%" }}>
                          <FileUpload handleChange={handleFileChange} files={files} />
                          <label style={{ marginLeft: '7px', display: 'flex', alignItems: 'center' }}>
                            <input 
                              type="checkbox"
                              checked={isInternalNotes}
                              onChange={internalNotesCheckboxChange}
                              style={{ marginRight: '5px', transform: 'scale(1.2)', cursor: 'pointer' }} />
                            Internal Notes
                          </label>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <ReactQuill
                            modules={modules}
                            theme="snow"
                            value={newMessage}
                            onChange={(content) => setNewMessage(content)}
                            placeholder="Type a message..."
                            style={editorStyles} // Apply custom styles to the content area
                          />
                          <button onClick={handleSendMessage} style={styles.sendButton} className="send-button">
                            <FontAwesomeIcon icon={faPaperPlane} /> Send
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={styles.noChats}>Select a ticket to view details</div>
                )}
              </Col>

                {isRightPanelOpen && tickets && tickets.length > 0 && (
                  <div className="ticket-list-container chat-ticket-details">
                  
                    <div className="text-center avatar mt-4">
                      <div style={styles.clientNameBlock} className="btn-color">
                        {selectedTicket && selectedTicket.clientName? getInitials(selectedTicket.clientName).toUpperCase(): ''}
                      </div>
                    </div>
                    <div style={{textAlign: 'center', fontWeight: 'bold'}}>{selectedTicket.clientName}</div>

                    <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}>
                      <hr style={{ border: "none", height: "2px", backgroundColor: "grey", flex: 1 }} />
                    </div>

                    
                    <div style={{marginLeft: '10px'}}>
                      <div><p className="details-font">USER INFORMATION</p></div>
                      <div><span style={styles.clientEmailDetails} className="details-font">
                        <FontAwesomeIcon icon={faEnvelope} />&nbsp;
                        {/* <span>Email:</span> */}
                        <span style={{ marginLeft: '5px' }}><a
                          href={`mailto:${selectedTicket && selectedTicket.clientEmail}`}
                          style={styles.emailLink}
                        >{selectedTicket && selectedTicket.clientEmail ? selectedTicket.clientEmail : ''}</a></span>
                      </span></div>
                      <div><span style={styles.clientEmailDetails} className="details-font">
                        <FontAwesomeIcon icon={faLink} />&nbsp;
                        {/* <span>Link:</span> */}
                        <span style={{ marginLeft: '4px' }}>
                          <a rel="noopener noreferrer" style={styles.emailLink} onClick={handleShareLink}>Share link on email </a></span>
                      </span></div>
                      
                    </div>
                    
                    <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}>
                      <hr style={{ border: "none", height: "2px", backgroundColor: "grey", flex: 1 }} />
                    </div>

                    <div style={{marginLeft: '10px'}}>
                      <p className="details-font">ADDITIONAL</p>
                    </div>
                    <div style={{ marginLeft: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }} className="mb-3">                      
                      <div style={{ display: 'grid', gridTemplateRows: 'auto auto'}}>
                        <span className="details-font">Ref ID:</span>
                        <span className="details-font-value">#{selectedTicket.ticket_no}</span>
                      </div>
                      <div style={{ display: 'grid', gridTemplateRows: 'auto auto'}}>
                        <span className="details-font">Requested:</span>
                        <span className="details-font-value">{selectedTicket.clientName}</span>
                      </div>
                    </div>

                    <div style={{ marginLeft: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>                      
                      <div style={{ display: 'grid', gridTemplateRows: 'auto auto'}}>
                        <span className="details-font">Status:</span>
                        {/* <span className="details-font-value">#{selectedTicket.statusName}</span> */}
                        <Form.Select
                          size="dd-width"
                          className= {`${!selectedTicket.isAssignedToSelf ? 'custom-disabled-select' : 'dropdown-color'}`}
                          value={selectedTicket.status}
                          onChange={(e) => handleStatusChange(selectedTicket.id, e.target.value)}
                          disabled = {!selectedTicket.isAssignedToSelf}
                          style={{  
                            
                            padding: '0.1rem 0.1rem 0.1rem 0.5rem', 
                            fontSize: '14px' 
                          }}
                        >
                          {statuses.map((status) => (
                            <option key={status.id} value={status.id}>
                              {status.name}
                            </option>
                          ))}
                        </Form.Select>

                      </div>
                      <div style={{ display: 'grid', gridTemplateRows: 'auto auto'}}>
                        <span className="details-font">Last Reply:</span>
                        <span className="details-font-value">{lastReply}</span>
                      </div>
                    </div>

                    <div style={{marginLeft: '10px'}} className="mt-2">
                      <span style={styles.clientEmailDetails} className="details-font">
                        <FontAwesomeIcon icon={faTicketAlt} />&nbsp;
                        <span style={{ marginLeft: '4px' }}>
                          <a 
                            rel="noopener noreferrer" 
                            style={styles.emailLink} 
                            onClick={viewTicketOperations}>View Ticket Operations </a></span>
                      </span>
                    </div>
                    
                    <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}>
                      <hr style={{ border: "none", height: "2px", backgroundColor: "grey", flex: 1 }} />
                    </div>

                    <div style={{ marginLeft: '10px' }}>
                      <p className="details-font">ASSIGNED ACCOUNT</p>
                    </div>

                    <div style={{ marginLeft: '10px' }} className="position-relative">
                      <div
                        className={`rounded-circle text-center ${
                          selectedTicket.assigned_to ? "profile-circle-color-red" : "profile-circle-color-dark-black"
                        }`}
                        style={{
                          width: "35px",
                          height: "35px",
                          lineHeight: "35px",
                          fontSize: "0.9em",
                          cursor:
                            user?.role === "organisation" ||
                            selectedTicket.isAssignedToSelf ||
                            selectedTicket.assigned_to === null
                              ? "pointer"
                              : "not-allowed",
                          opacity:
                            user?.role === "organisation" ||
                            selectedTicket.isAssignedToSelf ||
                            selectedTicket.assigned_to === null
                              ? 1
                              : 0.5,
                          zIndex: 2,
                          position: "relative",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAssignClick(selectedTicket);
                        }}
                      >
                        {selectedTicket.assigned_to
                          ? agents.find((agent) => agent.user_id === selectedTicket.assigned_to)?.name[0] || "?"
                          : "+"}
                      </div>

                      <div className="details-font-value">
                        {selectedTicket.assigned_to
                          ? agents.find((agent) => agent.user_id === selectedTicket.assigned_to)?.name || ""
                          : ""}
                      </div>

                      {assignDropdown === selectedTicket.id && (
                        <div
                          ref={assignDropdownRef}
                          className="position-absolute bg-white shadow p-3"
                          style={{
                            bottom: "45px",
                            left: "-25%",
                            transform: "translateX(-50%)",
                            zIndex: 10,
                            borderRadius: "5px",
                            width: "200px",
                            maxHeight: "250px",
                            overflowY: "auto",
                          }}
                        >
                          <strong>Assign to:</strong>
                          {agents.map((agent) => (
                            <div
                              key={agent.id}
                              onClick={() => handleAgentAssign(selectedTicket.id, agent, selectedTicket.assigned_to)}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={(e) => handleMouseLeave(e, agent)}
                              style={{
                                ...styles.listItem,
                                ...(agent === selectedAgent ? styles.selectedItem : {}),
                              }}
                            >
                              {agent.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}>
                      <hr
                        style={{
                          border: "none",
                          height: "2px",
                          backgroundColor: "grey",
                          flex: 1,
                          zIndex: 0,
                          position: "relative",
                        }}
                      />
                    </div>
                  </div>
              )}
            </div>
            {showTicketOperations && (
              <>
                <div className="modal-backdrop fade show"></div>
                <div
                  className="modal show d-block"
                  tabIndex="-1"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="modal-dialog" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                    <div className="modal-content">
                      
                      {/* Header */}
                      <div className="modal-header tbl-title-color">
                        <h5 className="modal-title">Ticket Operations</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowTicketOperations(false)}
                        ></button>
                      </div>

                      {/* Subject Below Header */}
                      <div className="px-4 pt-3 pb-2 border-bottom">
                        <p className="fw-semibold mb-0 d-flex align-items-center text-start">
                          <FontAwesomeIcon icon={faTag} className="me-2 text-secondary" />
                          <span>
                            Subject: <span className="text-dark">{selectedTicket.subject}</span>
                          </span>
                        </p>
                      </div>

                      {/* Body */}
                      <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        {ticketOperations && ticketOperations.length > 0 ? (
                          ticketOperations.map((operation, index) => {
                            const {
                              event_type,
                              created_by,
                              client_name,
                              ticket_status,
                              assign_to,
                              created_at
                            } = operation;

                            let eventMessage = '';
                            let icon = null;
                            let iconColor = '';

                            if (event_type === 'T_CRT') {
                              icon = faPlusCircle;
                              iconColor = '#28a745'; // Green
                              eventMessage = !created_by && client_name
                                ? `Ticket created by client (${client_name})`
                                : `Ticket created by ${created_by}`;
                            } else if (event_type === 'ST_CH') {
                              icon = faExchangeAlt;
                              iconColor = '#007bff'; // Blue
                              eventMessage = !created_by && client_name
                                ? `Status changed by client (${client_name})`
                                : `Status changed by ${created_by}`;
                            } else if (event_type === 'OW_CH') {
                              if (assign_to) {
                                icon = faUserCheck;
                                iconColor = '#ffc107'; // Yellow
                                eventMessage = `Ticket assigned to ${assign_to} by ${created_by}`;
                              } else {
                                icon = faUserSlash;
                                iconColor = '#dc3545'; // Red
                                eventMessage = `Ticket unassigned by ${created_by}`;
                              }
                            } else {
                              icon = faExchangeAlt;
                              iconColor = '#6c757d'; // Gray fallback
                              eventMessage = `Event: ${event_type}`;
                            }

                            return (
                              <div
                                key={index}
                                className="d-flex align-items-center mb-3 p-2 border rounded"
                                style={{ backgroundColor: '#f9f9f9' }}
                              >
                                <div className="me-3">
                                  <FontAwesomeIcon icon={icon} size="lg" style={{ color: iconColor }} />
                                </div>
                                <div className="flex-grow-1">
                                  <p className="mb-1 fw-bold">{eventMessage}</p>

                                  {ticket_status && (
                                    <p className="mb-1">
                                      <strong>Status:</strong> {ticket_status}
                                    </p>
                                  )}

                                  {assign_to && event_type !== 'OW_CH' && (
                                    <p className="mb-1">
                                      <strong>Assigned To:</strong> {assign_to}
                                    </p>
                                  )}

                                  <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                                    {formatUpworkDate(created_at).toLocaleString()}
                                  </p>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p className="text-muted fst-italic">No ticket operations available.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}  
          </main>
        </div>
      </div>
    </div>
  );
};

const styles = {
  ticketList: {
    width: "100%",
    height: "70vh",
    // padding: "10px",
    borderRight: "2px solid #ccc",
    overflowY: "auto"
  },
  ticketDetail: {
    flex: 1,
    padding: "0px",
    background: "#fff",
  },

  chatContainer: {
    display: "flex",
    flexDirection: "column",
    height: "95vh", // Full viewport height
    border: "1px solid #ccc",
    // backgroundColor: "#f9f9f9",
  },
  subjectHeader: {
    paddingLeft: '25px',
  },

  chatHeader: {
    position: "relative", // Allow absolute positioning for the button
    marginTop: "5px",
    textAlign: "center",
    color: "white",
  },
  closeButton: {
    position: "absolute", // Position button absolutely
    right: "10px", // Place it on the right
    top: "50%", // Vertically align it
    transform: "translateY(-50%)", // Center perfectly vertically
    padding: "5px 10px",
    backgroundColor: "#ACB3B2",
    border: "1px solid #010101",
    borderRadius: "4px",
    cursor: "pointer",
    color: "white",
    fontSize: "18px",
  },

  messageContainer: {
    marginBottom: "10px",
    position: "relative", // To position time below the box
  },

  messageName: {
    // position: "absolute",
    top: "-20px", // Name above the box
    left: "0",
    fontSize: "12px",
    fontWeight: "normal",
    color: "#888",
  },

  messageBox: {
    padding: "10px",
    borderRadius: "8px",
    maxWidth: "70%",
    wordWrap: "break-word",
    marginTop: "5px",
  },

  userMessage: {
    backgroundColor: "#D0E8FF",
    alignSelf: "flex-start",
  },
  supportMessage: {
    backgroundColor: "#A4E2B4",
    alignSelf: "flex-end",
  },

  messageTime: {
    fontSize: "12px",
    color: "#888",
    textAlign: "right", // Align time to the right
    marginTop: "5px",
  },

  messageInput: {
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#f0f0f0",
    maxHeight: "200px",
    minHeight: "100px",
    overflow: "auto",
  },

  inputField: {
    width: "85%",
    padding: "10px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },

  sendButton: {
    width: "10%",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    // display: "flex",
    alignItems: "flex-start",
    // justifyContent: "center",
    marginRight: "10px",
  },

  noMessages: {
    textAlign: "center",
    fontStyle: "italic",
    padding: "20px",
  },
  noChats: {
    top: "-20px", // Name above the box
    left: "0",
    fontSize: "16px",
    fontWeight: "normal",
    color: "#888",
    backgroundColor: "rgba(0, 0, 0, 0)",
  },
  statusTextContainer: {
    position: "static",
    top: "65px",
    right: "30px",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
  },
  statusItem: {
    display: "flex",
    alignItems: "center",
    margin: "5px",
  },
  statusBullet: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "8px",
  },
  statusText: {
    fontSize: "12px",
  },

  ticketDetail: {
    flex: 1,
    padding: "0px",
    background: "#fff",
  },

  messagesContainer: {
    flex: 1, // Allow this section to grow and shrink
    overflowY: "auto", // Scroll if content overflows
    padding: "10px",
    // background: "white",
  },
  shareLink: {
    position: "absolute", // Position button absolutely
    right: "10px", // Place it on the right
    top: "25px", // Vertically align it
    transform: "translateY(-50%)", // Center perfectly vertically
    cursor: "pointer",
    color: "blue",
    fontSize: "14px",
    textDecoration: "underline",
  },

  clientEmail: {
    position: "absolute", // Position button absolutely
    right: "10px", // Place it on the right
    top: "50%", // Vertically align it
    transform: "translateY(-50%)", // Center perfectly vertically
    color: "grey",
    fontSize: "14px",
  },

  listItem: {
    padding: "5px",
    margin: "5px 0",
    // border: "1px solid #ccc",
    borderRadius: "5px",
    cursor: "pointer",
    backgroundColor: "#fff", // Default background color
    transition: "background-color 0.3s", // Smooth transition on hover
  },
  selectedItem: {
    backgroundColor: "#D4D9DB", // Background color for selected item
  },
  hoverItem: {
    backgroundColor: "#D4D9DB", // Background color on hover
  },
  attachmentContainer: {
    position: 'relative',
    display: 'inline-block',
    // marginBottom: '10px',
    width: '200px',
    height: '38px',
    // backgroundColor: '#f0f0f0',
    // borderRadius: '8px',
    overflow: 'hidden',
    textAlign: 'center',
    // marginRight: '15px',
    // paddingTop: '10px',
    // border: '2px solid #d3d3d3',
    margin: '10px'
  },
  attachmentBox: {
    padding: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px',
  },
  downloadIcon: {
    top: '20%',
    display: "none", // Initially hide the download icon
    position: "absolute",
    right: "10px",
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  iconStyle: {
    color: 'gray',
  },
  grayBorder: {
    border: '2px solid #d3d3d3',
  },
  blackBorder: {
    border: '2px solid black',
  },
  fileName: {
    flex: 1, // Allow the name block to take up available space
    textAlign: "left", // Align text to the left
    overflow: "hidden", // Handle overflow
    textOverflow: "ellipsis", // Ellipsis for long names
    whiteSpace: "nowrap", // Prevent wrapping
    padding: "5px",
  },
  downloadIconVisible: {
    display: "block", // Show the download icon on hover
  },

  ticketTypeHeader: {
    position: "relative", // Allow absolute positioning for the button
    // padding: "10px",
    // backgroundColor: "#9ABEB8",
    borderBottom: "1px solid #ccc",
    // textAlign: "center",
    color: "white",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)", // Two columns
    marginLeft: '10px',
    alignItems: 'center',
    paddingTop: '10px'
  },

  ticketGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // Two columns
    marginLeft: '10px',
    alignItems: 'center'
  },

  clientNameBlock: {
    width: '70px',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#ffffff',
    // backgroundColor: '#ffcb37'
  },

  clientEmailDetails: {
    right: "10px", // Place it on the right
    top: "50%", // Vertically align it
    transform: "translateY(-50%)", // Center perfectly vertically
    color: "grey",
    fontSize: "12px",
  },

  emailLink: {
    color: '#007bff',        // Link color on hover
    textDecoration: 'underline',
    cursor: "pointer",
  },

};
export default AllTicket;
